export const BOOK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/otEsQnjX7mdUnCBcugsRi7/El_libro_del_despertar__volumen_1.png'

export const BOOK_MOCKUP_DARK =
  'https://cdn.magicpatterns.com/patterns/generated-images/ccfb46ea-097f-457b-97a0-0d5dcc2277c4.jpg'

export const PAYMENT_URL =
  'https://el-libro-deldespertar.impultienda.ar/checkout'

// Reemplaza por el enlace real de la plataforma de pago.
export const CHECKOUT_URL = '#oferta'

export const SUPPORT_EMAIL = 'soporte@ellibrodeldespertar.com'

export const heroHighlights = [
  'Conciencia y percepción',
  'Simbolismo ancestral y tradiciones espirituales',
  'Mente, pensamiento y realidad',
  'Libro digital en PDF',
  '3 bonos complementarios incluidos',
]

export const questions = [
  '¿Qué papel desempeña la conciencia en nuestra percepción del mundo?',
  '¿Cómo influyen nuestras creencias en aquello que consideramos real?',
  '¿Qué significados esconden los símbolos que han acompañado a distintas civilizaciones?',
]

export const chapters = [
  {
    number: '01',
    title: 'La conciencia y la percepción',
    description:
      'Explora cómo interpretamos nuestras experiencias y cómo nuestra percepción participa en la construcción de nuestra visión del mundo.',
  },
  {
    number: '02',
    title: 'El poder de la mente',
    description:
      'Reflexiona sobre los pensamientos, las creencias y su influencia en nuestras decisiones y experiencias cotidianas.',
  },
  {
    number: '03',
    title: 'Simbolismo y conocimiento ancestral',
    description:
      'Adéntrate en los símbolos, mitos y representaciones presentes en antiguas tradiciones religiosas, culturales y espirituales.',
  },
  {
    number: '04',
    title: 'Luz, energía y realidad',
    description:
      'Conoce perspectivas espirituales y simbólicas sobre la luz, la vibración y la relación entre el ser humano y el universo.',
  },
  {
    number: '05',
    title: 'La conexión entre información y comprensión',
    description:
      'Descubre por qué reunir datos no siempre equivale a comprender y cómo la reflexión puede ayudarte a conectar diferentes ideas.',
  },
  {
    number: '06',
    title: 'Una mirada más amplia sobre la existencia',
    description:
      'Explora preguntas relacionadas con el propósito, las creencias, la unidad y las distintas maneras de interpretar la realidad.',
  },
]

export const bonuses = [
  {
    label: 'Bono 01',
    title: 'Cuaderno de Reflexión y Despertar Interior',
    lead: 'Un cuaderno digital con preguntas de reflexión para explorar creencias, observar patrones de pensamiento y registrar las ideas más importantes de la lectura.',
    body: 'Un espacio para escribir tus descubrimientos, organizar tus pensamientos y profundizar en las preguntas que surjan durante el recorrido.',
  },
  {
    label: 'Bono 02',
    title: 'Guía de Simbolismo Ancestral',
    lead: 'Una guía introductoria para explorar símbolos, mitos y representaciones espirituales, con explicaciones y preguntas que te ayudarán a profundizar en sus posibles significados culturales.',
    body: 'Descubre diferentes interpretaciones y amplía tu perspectiva sobre las representaciones simbólicas que aparecen en distintas tradiciones.',
  },
  {
    label: 'Bono 03',
    title: 'Diario de Conciencia de 7 Días',
    lead: 'Un recorrido de siete días con ejercicios breves de observación, escritura y reflexión para acompañar la lectura.',
    body: 'Dedica unos minutos cada día a observar tus pensamientos, examinar tus interpretaciones y registrar las ideas que más llamen tu atención.',
  },
]

export const forYou = [
  'Sientes curiosidad por la conciencia, la percepción y la mente.',
  'Te interesa el simbolismo de las antiguas civilizaciones.',
  'Disfrutas explorando temas filosóficos y espirituales.',
  'Quieres cuestionar ideas y reflexionar sobre distintas interpretaciones de la realidad.',
  'Buscas una lectura que te invite a pensar más allá de lo superficial.',
]

export const notForYou = [
  'Solo buscas entretenimiento ligero.',
  'Prefieres respuestas simples para preguntas complejas.',
  'No disfrutas de la lectura reflexiva ni de explorar diferentes perspectivas.',
]

export const steps = [
  {
    title: 'Compra el libro',
    description: 'Pulsa el botón de compra y completa el pago único de 15 USD.',
  },
  {
    title: 'Recibe tus archivos',
    description:
      'Una vez confirmado el pago, accede al libro y a los tres bonos mediante el enlace de entrega configurado.',
  },
  {
    title: 'Empieza a leer',
    description:
      'Abre los archivos PDF desde tu dispositivo compatible y avanza a tu propio ritmo.',
  },
]

export const offerIncludes = [
  'El libro digital EL LIBRO DEL DESPERTAR',
  'Cuaderno de Reflexión y Despertar Interior',
  'Guía de Simbolismo Ancestral',
  'Diario de Conciencia de 7 Días',
]

export const faqs = [
  {
    question: '¿Qué recibiré al comprar?',
    answer:
      'El libro digital EL LIBRO DEL DESPERTAR en PDF y los tres bonos complementarios anunciados.',
  },
  {
    question: '¿Hay pagos mensuales?',
    answer:
      'No. La oferta se plantea como un pago único, sin suscripciones ni cargos recurrentes.',
  },
  {
    question: '¿Cómo recibiré el libro?',
    answer:
      'Recibirás las instrucciones o el enlace de descarga una vez confirmado el pago, según la plataforma que utilices.',
  },
  {
    question: '¿Puedo leerlo desde el teléfono?',
    answer:
      'Puedes abrir el PDF desde un teléfono, una tableta o un ordenador que admita ese formato.',
  },
  {
    question: '¿Necesito conocimientos previos?',
    answer:
      'No se establecen requisitos previos específicos. Está orientado a personas interesadas en explorar temas filosóficos, simbólicos y espirituales.',
  },
  {
    question: '¿El libro garantiza resultados personales o espirituales?',
    answer:
      'No. El libro ofrece ideas y perspectivas para la reflexión. La experiencia, la interpretación y los resultados personales pueden variar entre lectores.',
  },
]
